module.exports = __webpack_public_path__ + "static/media/miami.eed4fbc3.webp";